// extracted by mini-css-extract-plugin
export default {"parent":"UserAdminTasksWizard_parent__QdG7W","wrapper":"UserAdminTasksWizard_wrapper__LvS8B"};